import { Link } from "react-router";
import "../landing/landing.css";

interface LegalPageProps {
  title: string;
  eyebrow: string;
  lastUpdated: string;
  attribution?: React.ReactNode;
  children: React.ReactNode;
}

export function LegalPage({ title, eyebrow, lastUpdated, attribution, children }: LegalPageProps) {
  return (
    <div className="ld-root">
      {/* Minimal nav */}
      <nav className="ld-nav">
        <Link className="ld-logo" to="/">
          GAA<span className="ld-logo-accent">MED</span>
        </Link>
        <div style={{ flex: 1 }} />
        <Link className="ld-nav-ghost" to="/">
          ← Home
        </Link>
      </nav>

      <main className="ld-legal-main">
        <Link className="ld-legal-back" to="/">
          ← Back to Gaamed
        </Link>
        <span className="ld-legal-eyebrow">{eyebrow}</span>
        <h1 className="ld-legal-title">{title}</h1>
        <p className="ld-legal-meta">
          Last updated: {lastUpdated}
          {attribution && <><br />{attribution}</>}
        </p>
        <div className="ld-legal-body">{children}</div>
      </main>
    </div>
  );
}
